import { useNavigate } from "react-router-dom";
import PageLayout from "./PageLayout ";

export default function Collaboration() {
  const navigate = useNavigate();
  return (
    <PageLayout
      title="Legal & Research Collaboration"
      desc="Collaborate with experts to strengthen legal research, policy development, and advocacy initiatives."
    >
      <div className="advocacy-content">
        <p>
          In an evolving legal landscape, research and collaboration are
          essential for developing strong, effective, and sustainable solutions
          to complex legal and societal challenges. At ICSAJ (International
          Council of Sanatan Advocacy & Justice), we believe that meaningful
          progress is achieved through collective knowledge, shared expertise,
          and structured collaboration.
        </p>

        <p>
          Our Legal & Research Collaboration initiative is designed to bring
          together advocates, researchers, academicians, and professionals who
          are committed to strengthening legal awareness, policy development,
          and advocacy efforts. By working together, we aim to create impactful
          research that contributes to informed decision-making and supports
          justice-oriented initiatives.
        </p>

        <p>
          Collaboration provides a platform to exchange ideas, analyze legal
          issues, and develop well-researched solutions that address real-world
          challenges. It allows professionals from different fields to combine
          their strengths, resulting in deeper insights and more effective
          outcomes. Through this initiative, ICSAJ seeks to build a network of
          individuals who are dedicated to advancing legal knowledge and social
          responsibility.
        </p>

        <h4 className="mt-4">Areas of Collaboration</h4>

        <ul className="advocacy-list">
          <li>Legal research and policy analysis</li>
          <li>Public interest studies and reports</li>
          <li>Case studies and documentation</li>
          <li>Workshops, seminars, and academic discussions</li>
          <li>Collaboration with legal institutions and think tanks</li>
        </ul>

        <p>
          ICSAJ encourages participants to contribute through research papers,
          reports, legal opinions, and academic discussions. These contributions
          not only enhance individual expertise but also support the larger goal
          of building a well-informed and legally aware society.
        </p>

        <p>
          Our collaboration model is based on professionalism, ethical conduct,
          and respect for diverse perspectives. We ensure that all research
          activities are carried out in a structured and lawful manner,
          maintaining accuracy, credibility, and integrity.
        </p>

        <p>
          By participating in this initiative, you gain access to a network of
          experienced professionals, opportunities for learning, and a platform
          to showcase your work. Whether you are a law student, researcher, or
          practicing professional, your contribution can play a significant role
          in shaping legal awareness and advocacy efforts.
        </p>

        <p>
          ICSAJ aims to foster a collaborative environment where knowledge is
          shared, ideas are respected, and solutions are developed for the
          benefit of society. Together, we can create impactful research that
          supports justice, strengthens legal frameworks, and contributes to
          long-term societal development.
        </p>

        <div className="text-center mt-4">
          <button
            className="btn btn-danger px-4 py-2"
            onClick={() => navigate("/join-volunteer")}
          >
            Collaborate With Us
          </button>
        </div>
      </div>
    </PageLayout>
  );
}
